import styled from 'styled-components/native'
import AddressPickerSearchCard from 'APP/Converse/AddressPickerSearchCard'
import { SafeAreaView } from 'react-native-safe-area-context'

export const Container = styled.View`
  flex-grow: 0;
  flex-shrink: 1;
`

export const ModalContainer = styled(SafeAreaView)`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.elementsBg};
`

export const WebModalOverlay = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`

export const WebModalBackdrop = styled.Pressable`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(26, 26, 26, 0.75);
`

export const WebModalContent = styled.View`
  width: 90%;
  max-width: 640px;
  height: 500px;
  border-radius: ${({ theme }) => theme.metrics.borderRadius.medium}px;
  padding: ${({ theme }) => theme.metrics.baseMargin / 0.8}px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.elementsBg};
`

export const StyledAddressPickerSearchCard = styled(AddressPickerSearchCard)`
  box-shadow: none;
  shadow-color: transparent;
  elevation: 0;
  margin: 0;
`
